const PlayIcon = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <foreignObject x="0" y="0" width="48" height="48">
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        backgroundColor: 'rgba(96, 96, 96, 0.58)',
                        backdropFilter: 'blur(8px)',
                        WebkitBackdropFilter: 'blur(8px)',
                    }}
                />
            </foreignObject>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M34.5167 22.6568C35.6222 23.2096 35.6222 24.7873 34.5167 25.3401L20.1708 32.513C19.1734 33.0117 18 32.2864 18 31.1714L18 16.8255C18 15.7104 19.1734 14.9852 20.1708 15.4838L34.5167 22.6568Z"
                    fill="white"
                />
            </g>
        </svg>
    );
};

export default PlayIcon;
